import store from '@/store/index'
import * as trackedVehicleHelpers from '@/store/assets/vehicles/trackedVehicles.helpers'
import * as trackedUnitHelpers from '@/store/units/trackedUnits.helpers'

export default {}

/**
 * Returns the full state object of the asset tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['monitoring/positionReplayWidgetModule/get']
}

export const getVehicle = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getVehicle']
}

export const setVehicle = (vehicle) => {
  store.commit('monitoring/positionReplayWidgetModule/setVehicle', vehicle)
}

export const getUnit = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getUnit']
}

export const setUnit = (unit) => {
  store.commit('monitoring/positionReplayWidgetModule/setUnit', unit)
}

export const getDate = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getDate']
}

export const setDate = (date) => {
  store.commit('monitoring/positionReplayWidgetModule/setDate', date)
}

export const getFromTime = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getFromTime']
}

export const setFromTime = (fromTime) => {
  return store.commit('monitoring/positionReplayWidgetModule/setFromTime', fromTime)
}

export const getToTime = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getToTime']
}

export const setToTime = (toTime) => {
  return store.commit('monitoring/positionReplayWidgetModule/setToTime', toTime)
}

export const clearTelemetry = () => {
  store.commit('monitoring/positionReplayWidgetModule/clearTelemetry')
}

export const getViewMode = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getViewMode']
}

export const setViewMode = (viewMode) => {
  store.commit('monitoring/positionReplayWidgetModule/setViewMode', viewMode)
}

export const setReplayMode = (replayMode) => {
  store.commit('monitoring/positionReplayWidgetModule/setReplayMode', replayMode)
}

export const getReplayMode = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getReplayMode']
}

/**
 * Sets the current replay speed.
 *
 * 0 = Paused, -1 = Rewind, 1 = Play, < -1 = Rewind Fast, > 1 Forward Fast
 *
 * @param replaySpeed
 */
export const setReplaySpeed = (replaySpeed) => {
  store.commit('monitoring/positionReplayWidgetModule/setReplaySpeed', replaySpeed)
}

export const getReplaySpeed = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getReplaySpeed']
}

/**
 * Get the current position/telemetry for the point in time in the replay.
 *
 * @returns null|Object
 */
export const getRecord = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getRecord']
}

/**
 * Set the current position/telemetry for the point in time in the replay.
 *
 * @param record
 */
export const setRecord = (record) => {
  store.commit('monitoring/positionReplayWidgetModule/setRecord', record)
}

export const getRecordCount = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getRecordCount']
}

export const getIsFirstRecord = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getIsFirstRecord']
}

export const setIsFirstRecord = (isFirstRecord) => {
  store.commit('monitoring/positionReplayWidgetModule/setIsFirstRecord', isFirstRecord)
}

export const getIsLastRecord = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getIsLastRecord']
}

export const setIsLastRecord = (isLastRecord) => {
  store.commit('monitoring/positionReplayWidgetModule/setIsLastRecord', isLastRecord)
}

export const incReplaySpeed = () => {
  store.commit('monitoring/positionReplayWidgetModule/incReplaySpeed')
}

export const decReplaySpeed = () => {
  store.commit('monitoring/positionReplayWidgetModule/decReplaySpeed')
}

export const incRecordIdx = () => {
  store.commit('monitoring/positionReplayWidgetModule/incRecordIdx')
}

export const decRecordIdx = () => {
  store.commit('monitoring/positionReplayWidgetModule/decRecordIdx')
}

export const setRecordIdx = (recordIdx, panTo = false) => {
  store.commit('monitoring/positionReplayWidgetModule/setRecordIdx', { recordIdx, panTo })
}

export const selectFirstRecord = () => {
  store.commit('monitoring/positionReplayWidgetModule/selectFirstRecord')
}

export const selectLastRecord = () => {
  store.commit('monitoring/positionReplayWidgetModule/selectLastRecord')
}

export const reset = () => {
  store.commit('monitoring/positionReplayWidgetModule/reset')
}

export const getReplayProgress = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getReplayProgress']
}

export const refreshPeriod = () => {
  store.commit('monitoring/positionReplayWidgetModule/refreshPeriod')
}

export const setTooManyIcons = (tooManyIcons) => {
  store.commit('monitoring/positionReplayWidgetModule/setTooManyIcons', tooManyIcons)
}

export const getTooManyIcons = () => {
  return store.getters['monitoring/positionReplayWidgetModule/getTooManyIcons']
}

export const updateEventMarkers = () => {
  store.commit('monitoring/positionReplayWidgetModule/updateEventMarkers')
}

export const assetCount = () => {
  return trackedVehicleHelpers.trackedVehicleCount() +
    trackedUnitHelpers.trackedUnitCount()
}

export const setFirstAvailableAsset = () => {
  if (trackedVehicleHelpers.trackedVehicleCount() > 0) {
    let vehicle = getVehicle()
    if (vehicle === null) {
      // Try and set a vehicle based on the find dialog
      vehicle = trackedVehicleHelpers.trackedVehicle()
      if (vehicle !== null) {
        setVehicle(Object.assign({}, vehicle))
      }
    }
  } else if (trackedUnitHelpers.trackedUnitCount() > 0) {
    let unit = getUnit()
    if (unit === null) {
      unit = trackedUnitHelpers.trackedUnit()
      if (unit !== null) {
        setUnit(Object.assign({}, unit))
      }
    }
  } else {
    setUnit(null)
    setVehicle(null)
  }
}



// WEBPACK FOOTER //
// ./src/store/monitoring/positionReplayWidget.helpers.js